

export const Currencies = {
    HUF: 'HUF',
    EUR: 'EUR'
}

export const TicketStates = {
    Open: "Open",
    Confirmed: "Confirmed",
    InPorgress: "In Porgress",
    Resolved: "Resolved",
    Removed: "Removed",
}

